export const MODULE_NAME = 'financeiro_P&L'
export const PERM_LOADING = null
export const PAGE_SIZE = 20

/** Filtros iniciais da análise comparativa. Operação fixa da PASI; Limpar restaura estes valores. */
export const PASI_ANALISE_CNPJ = '07.930.471/0001-48'
export const PASI_ANALISE_CONTA = '130062190'
export const PASI_ANALISE_STATUS_RECIBO = 'Pago'
export const PASI_ANALISE_TIPO_EXTRATO = 'credit' as const
export const PASI_ANALISE_IMPOSTO_PCT = '6,15'
export const PASI_ANALISE_MARGEM_PCT = '0'
/** Tamanho de página padrão da análise comparativa. */
export const PASI_ANALISE_PAGE_SIZE = 50
export const PASI_ANALISE_PAGE_SIZE_OPTIONS = [20, 50, 100, 150] as const

export function tabButtonClass(active: boolean): string {
  return `py-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
    active
      ? 'border-primary-600 text-primary-600 dark:text-primary-400'
      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
  }`
}

export function subTabButtonClass(active: boolean): string {
  return tabButtonClass(active)
}

export const CARD_CLASS =
  'bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden'

export const FILTER_CARD_CLASS =
  'rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800'

export const ERROR_BANNER_CLASS =
  'mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-800 dark:bg-red-900/20 dark:text-red-300'

export const PAGINATION_BTN_CLASS =
  'px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700'

export function paginationPageClass(active: boolean): string {
  return `px-3 py-2 text-sm font-medium rounded-md ${
    active
      ? 'bg-primary-600 text-white'
      : 'text-gray-500 bg-white border border-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700'
  }`
}

export const FIELD_LABEL_CLASS =
  'mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400'

function pad2(n: number | string): string {
  return String(n).padStart(2, '0')
}

/** Formata data (ou data+hora) para exibição BR: DD/MM/YYYY ou DD/MM/YYYY HH:mm. */
export function formatDatePtBr(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—'
  const raw = String(value).trim()
  if (!raw || raw === '—') return '—'

  // Já em DD/MM/YYYY (opcionalmente com hora)
  const br = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})(?:[ T](\d{1,2}):(\d{2})(?::\d{2})?)?$/.exec(raw)
  if (br) {
    const y = br[3].length === 2 ? `20${br[3]}` : br[3]
    const datePart = `${pad2(br[1])}/${pad2(br[2])}/${y}`
    if (br[4] !== undefined) return `${datePart} ${pad2(br[4])}:${pad2(br[5])}`
    return datePart
  }

  // ISO YYYY-MM-DD ou YYYY-MM-DDTHH:mm[:ss]
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::\d{2})?(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?)?$/.exec(
    raw
  )
  if (iso) {
    const datePart = `${iso[3]}/${iso[2]}/${iso[1]}`
    if (iso[4] !== undefined) return `${datePart} ${iso[4]}:${iso[5]}`
    return datePart
  }

  // Serial Excel (número)
  if (/^\d+(\.\d+)?$/.test(raw)) {
    const serial = Number(raw)
    if (serial > 20000 && serial < 100000) {
      const utc = Date.UTC(1899, 11, 30) + Math.round(serial * 86400000)
      const d = new Date(utc)
      return `${pad2(d.getUTCDate())}/${pad2(d.getUTCMonth() + 1)}/${d.getUTCFullYear()}`
    }
  }

  const parsed = new Date(raw)
  if (!Number.isNaN(parsed.getTime())) {
    const hasTime = /T|\d{1,2}:\d{2}/.test(raw)
    if (hasTime) {
      return parsed.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }
    return parsed.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  return raw
}

/** Data/hora ISO → DD/MM/YYYY HH:mm. */
export function formatDateTimePtBr(value: string | null | undefined): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return formatDatePtBr(value)
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** Ano/mês/dia da pasta → DD/MM/YYYY. */
export function formatFolderDatePtBr(
  year: string | null | undefined,
  month: string | null | undefined,
  day: string | null | undefined
): string {
  if (!year || !month || !day) return '—'
  return `${pad2(day)}/${pad2(month)}/${year}`
}
